export const previewSavedPaymentMethods = {
	cc: [
		{
			method: {
				gateway: 'credit-card',
				last4: '5678',
				brand: 'Visa',
			},
			expires: '12/20',
			is_default: false,
			tokenId: '1',
		},
	],
};
